var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPartnership(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 88,
    height: 82.331,
    viewBox: "0 0 88 82.331",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Orion_user-group",
    transform: "translate(1.5 1.561)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "layer2",
    d: "M27.4,15.6c1.275-4.675,4.533-10.483,12.75-10.483,0,0,22.667-7.225,22.667,15.867,0,19.408,4.392,21.533,9.067,26.208A80.183,80.183,0,0,1,53.75,49.315v2.267c0,2.267-.425,6.8,10.908,9.067S76.417,71.981,76.417,71.981H46.667",
    transform: "translate(8.583 -4.044)",
    fill: "none",
    stroke: "#e0a403",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "layer1",
    d: "M53.142,67.475c-11.333-1.558-11.333-5.667-11.333-7.933V58.267a20.683,20.683,0,0,0,5.95-9.917c3.4,0,4.25-7.225,4.25-8.217s-.283-5.1-1.842-5.525C55.833,14.775,38.833,6.275,24.1,16.475c-6.233,0-8.217,9.067-5.95,18.133-1.558,0-1.842,4.25-1.842,5.383s.85,8.217,4.25,8.217c1.133,4.108,4.25,7.508,6.942,9.917v1.417c0,2.267-.85,6.517-12.325,7.933S2,79.942,2,79.942H64.333S64.475,69.034,53.142,67.475Z",
    transform: "translate(-2 -0.671)",
    fill: "none",
    stroke: "#c3001b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPartnership);
export default __webpack_public_path__ + "static/media/icon-partnership.e2b92bb6341c21ed90c9f11bcb206741.svg";
export { ForwardRef as ReactComponent };